<template>
  <svg :width="width" :height="height" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.29289 4.70711C3.90237 5.09763 3.90237 5.7308 4.29289 6.12132L22.6777 24.5061C23.0682 24.8966 23.7014 24.8966 24.0919 24.5061C24.4824 24.1156 24.4824 23.4824 24.0919 23.0919L5.70711 4.70711C5.31658 4.31658 4.68342 4.31658 4.29289 4.70711Z" :fill="color"/>
    <path d="M4.70711 24.7071C5.09763 25.0976 5.7308 25.0976 6.12132 24.7071L24.5061 6.32233C24.8966 5.93181 24.8966 5.29864 24.5061 4.90812C24.1156 4.51759 23.4824 4.51759 23.0919 4.90812L4.70711 23.2929C4.31658 23.6834 4.31658 24.3166 4.70711 24.7071Z" :fill="color"/>
  </svg>
</template>

<script>
export default{
  name: 'closeIcon',
  props: {
    color: {
      type: String,
      required: false,
      default: 'currentColor'
    },
    width: {
      type: [String, Number],
      default: '30'
    },
    height: {
      type: [String, Number],
      default: '30'
    }
  }
}</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/icon/CloseIcon.vue